import React from 'react';
import './Experience.css';

export default function ExperienceCard({
  title,
  duration,
  company,
  logo,
  address,
  contact,
  website,
  responsibilities
}) {
  return (
    <div className="experience-card">

      {/* Header */}
      <div className="experience-header">
        <h2 className="experience-title">{title}</h2>
        <span className="experience-duration">{duration}</span>
      </div>

      {/* Company Section */}
      <div className="company-section">

        {/* Fixed logo container */}
        <div className="logo-wrapper">
          <img src={logo} alt={company} />
        </div>

        {/* Company details */}
        <div className="company-details">
          <h3>{company}</h3>
          <p>{address}</p>
          <p>{contact}</p>
          <a href={website} target="_blank" rel="noopener noreferrer">
            {website}
          </a>
        </div>
      </div>

      <hr />

      {/* Responsibilities */}
      <h4 className="workExperience-section-title">Responsibilities & Achievements</h4>

      <ul className="responsibilities-list">
        {responsibilities.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

    </div>
  );
}
